/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import { memoize } from 'lodash/fp';
import ReversibleFragment from 'app/components/commons/ReversibleFragment';
import DaySelectField from './DaySelectField';
import FormLabel from './FormLabel';
import MonthSelectField from './MonthSelectField';
import YearSelectField from './YearSelectField';

type Props = {
  disabled?: boolean,
  label?: string,
  lightContent?: boolean,
  monthFirst?: boolean,
  onChange: string => void,
  required?: boolean,
  value?: string,
};

type State = {
  day?: string,
  month?: string,
  year?: string,
};

const Wrapper = glamorous.div({
  display: 'flex',
  margin: '0 -5px',
});

const Element = glamorous.div({
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
  padding: '0 5px',
});

class HistoricDateField extends React.Component<Props, State> {
  props: Props;

  state: State = {
    day: undefined,
    month: undefined,
    year: undefined,
  };

  static defaultProps = {
    disabled: false,
    label: undefined,
    lightContent: false,
    monthFirst: false,
    required: false,
    value: undefined,
  };

  constructor(props: Props, ...args: Array<*>) {
    super(props, ...args);

    if (props.value) {
      const [year, month, day] = props.value.split('-');
      this.state = {
        day,
        month,
        year,
      };
    }
  }

  UNSAFE_componentWillReceiveProps({ value }: Props) {
    if (value !== this.props.value) {
      if (value) {
        const [year, month, day] = value.split('-');
        this.setState({
          day,
          month,
          year,
        });
      } else {
        this.setState({
          day: undefined,
          month: undefined,
          year: undefined,
        });
      }
    }
  }

  handleChange = memoize((key: string) => (value: string) => {
    this.setState({
      [key]: value,
    }, () => {
      const { day, month, year } = this.state;
      if (day && month && year) {
        this.props.onChange(`${year}-${month}-${day}`);
      }
    });
  });

  render() {
    const { disabled, label, lightContent, monthFirst, required } = this.props;
    const { day, month, year } = this.state;

    return (
      <div>
        {label && (
          <FormLabel
            lightContent={lightContent}
            required={required}
          >
            {label}
          </FormLabel>
        )}
        <Wrapper>
          <ReversibleFragment reverse={monthFirst}>
            <Element>
              <DaySelectField
                disabled={disabled}
                lightContent={lightContent}
                onChange={this.handleChange('day')}
                required={required}
                value={day}
              />
            </Element>
            <Element>
              <MonthSelectField
                disabled={disabled}
                lightContent={lightContent}
                onChange={this.handleChange('month')}
                required={required}
                value={month}
              />
            </Element>
          </ReversibleFragment>
          <Element>
            <YearSelectField
              disabled={disabled}
              lightContent={lightContent}
              onChange={this.handleChange('year')}
              required={required}
              value={year}
            />
          </Element>
        </Wrapper>
      </div>
    );
  }
}

export default HistoricDateField;
